<div class="error" role="alert">
  <div class="error-title py-1">
    <i class="is-inline-block icon-error-exclamation icon-very-large pr-1"></i>
    <span
      class="is-inline-block px-1 is-size-6 has-text-weight-semibold is-capitalized"
      >{{ data.message || "Unknown Error" }}</span
    >
  </div>
  <div class="error-message py-1 is-size-7">
    <span>{{
      data.detail || "Something unexpected happened. Please try again later."
    }}</span>
  </div>
  <div class="error-cta py-4">
    <button class="button is-primary is-fullwidth is-medium" (click)="close()">
      <span class="is-size-6">Try again</span>
    </button>
  </div>
</div>
